
























import Vue from "vue";
import { Trans } from "../shared/scripts/helpers/translation/translation";

export default Vue.extend({
    computed: {
        homePageUrl: function(): string {
            return `${process.env.VUE_APP_IMMOWEB_URL}/${Trans.currentLocale}`;
        }
    }
});
